import ObjetoConId from "../tipos/objetoConId";
import MetConstants from "../datosVars/metConstants";

const FIELD_NOMBRE = "nombre";

class Estacion extends ObjetoConId {
  constructor(obj) {
    super(obj.id);

    for (let prop in obj){
      if (obj.has )
        this[prop]= obj[prop];
    }

    this.idStr = obj.idStr;
    this.nombre = obj.nombre;
    this.latitud = obj.latitud;
    this.longitud = obj.longitud;
    this.altitud = obj.altitud;
    this.cotaBarom = obj.cotaBarom;
    this.idOACI = obj.idOACI;
    this.codigoOMM = obj.codigoOMM;
    this.codigoPluviometrico = obj.codigoPluviometrico;
    this.idAutomatica = obj.idAutomatica;
    this.principal = obj.principal;
    this.tipoMet = obj.tipoMet;
    this.tipoPluvio = obj.tipoPluvio;
    this.tipoExterna = obj.tipoExterna;
    this.tipoAutomatica = obj.tipoAutomatica;
    this.tipoAeronautica = obj.tipoAeronautica;
    this.emite_synop = obj.emite_synop;
    this.gerencia = obj.gerencia;
    this.estado = obj.estado;
    this.husoHorario = obj.husoHorario;
    this.usarDatosEnProductos = obj.usarDatosEnProductos;
    this.wigosSerieId = obj.wigosSerieId;
    this.wigosEmisorId = obj.wigosEmisorId;
    this.wigosNroExpedicion = obj.wigosNroExpedicion;
    this.wigosLocalId = obj.wigosLocalId;
    this.evalLab = obj.evalLab;
    this.activa = obj.activa;
  }

  getTextoGerenciaReg() {
    return MetConstants.gerenciasNombres[this.gerencia];
  }

  getWigosIdCompleto(){
    return (this.wigosSerieId && this.wigosEmisorId && this.wigosNroExpedicion && this.wigosLocalId)? this.wigosSerieId +"-"+this.wigosEmisorId + "-" +this.wigosNroExpedicion+ "-" +this.wigosLocalId:"";
  }

  getLatLng(){
    return {lat:this.latitud, lng:this.longitud}
  }
}

function crearEstacion(obj) {
  return new Estacion(obj);
}

export { Estacion as default, crearEstacion, FIELD_NOMBRE };
